'use strict';

const { String } = require('../lib/types');
const { make } = require('../lib/build-spec');

module.exports = {
    dietaryRestriction: make(
        String,
        'dietaryRestriction',
        'Does the patient have any dietary restrictions?'
    ),
    dietaryRestrictionDetails: make(
        String,
        'dietaryRestrictionDetails',
        'Dietary Restriction Details'
    ),
    dietaryPreference: make(
        String,
        'dietaryPreference',
        'Does the patient have any dietary preferences?'
    ),
    dietaryPreferenceDetails: make(
        String,
        'dietaryPreferenceDetails',
        'Dietary Preference Details'
    ),

    exerciseFrequency: make(String, 'exerciseFrequency', 'Exercise Frequency'),
    exerciseType: make(String, 'exerciseType', 'What type of exercise?'),

    culturalNeeds: make(
        String,
        'culturalNeeds',
        'Does the patient have any cultural needs affecting his or her medical treatment?'
    ),
    culturalNeedsDetails: make(
        String,
        'culturalNeedsDetails',
        'Cultural Needs Details'
    ),

    religiousActivities: make(
        String,
        'religiousActivities',
        'Does the patient need help attending religious activities?'
    ),
    religiousPreference: make(
        String,
        'religiousPreference',
        'Religious Preference'
    ),
    religiousOrganization: make(
        String,
        'religiousOrganization',
        'Name of Religious Organization'
    ),
    religiousLeader: make(String, 'religiousLeader', 'Religious Leader'),

    religiousOrganizationNumber: make(
        String,
        'religiousOrganizationNumber',
        'Religious Organization Phone Number'
    ),
    spiritualDistress: make(
        String,
        'spiritualDistress',
        'Is the patient experiencing any spiritual distress?'
    ),
    spiritualDistressDetails: make(
        String,
        'spiritualDistressDetails',
        'Spiritual Distress Details'
    ),

    hobbies: make(String, 'hobbies', 'Hobbies'),
    startDate: make(String, 'startDate', 'From'),
    socialClubs: make(String, 'socialClubs', 'List social clubs'),
    recentTravel: make(String, 'recentTravel', 'Recent Travel'),

    branch: make(String, 'branch', 'Branch'),
    pets: make(String, 'pets', 'List pets & names'),
    endDate: make(String, 'endDate', 'To'),
    militaryCombat: make(
        String,
        'militaryCombat',
        'Was the patient ever in combat?'
    ),

    militaryService: make(String, 'militaryService', 'Military Service?'),
    militaryBenefits: make(String, 'militaryBenefits', 'Military Benefits?')
};
